import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import skillsBasedJobsServices from '../services/skillsBasedJobsServices';

// async thunk
export const fetchContentConfig = createAsyncThunk(
  'contentConfig/fetchContentConfig',
  async (_, { rejectWithValue }) => {
    try {
      const res = await skillsBasedJobsServices.get(`/skill/api/v1/content/get`);
      console.log("res ",res.data)
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contentConfigSlice = createSlice({
  name: 'contentConfig',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContentConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContentConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchContentConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contentConfigSlice.reducer;
